import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Paper from "@mui/material/Paper";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import { useUpgrade } from "context/upgrade";

function BottomNav({ routes }) {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { openUpgrade } = useUpgrade();

  // Filtra as rotas que devem aparecer no menu inferior
  // Ignora "Sair" (sign-in) e rotas sem ícone
  const validRoutes = routes.filter(
    (route) =>
      route.icon &&
      route.key !== "sign-in" &&
      route.key !== "notifications" &&
      (route.type === "collapse" || route.type === "examples" || route.type === "route")
  );

  useEffect(() => {
    // Define o ícone ativo com base na URL atual
    const currentIndex = validRoutes.findIndex((r) => {
        if (r.route === '/dashboard' && location.pathname === '/dashboard') return true;
        if (r.route !== '/dashboard' && location.pathname.startsWith(r.route)) return true;
        return false;
    });
    
    if (currentIndex !== -1) {
      setValue(currentIndex);
    }
  }, [location, validRoutes]);

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200, // Garante que fique acima de outros elementos
        display: { xs: "block", md: "none" }, // Só aparece em mobile/tablet pequeno
        backgroundColor: darkMode ? "#1a2035" : "#fff",
      }}
      elevation={3}
    >
      <MDBox sx={{ overflowX: "auto", width: "100%" }}>
        <BottomNavigation
          value={value}
          showLabels
          onChange={(event, newValue) => {
            // Recurso premium para DJ free: abre o upgrade e mantém a aba atual
            if (validRoutes[newValue].locked) {
              openUpgrade();
              return;
            }
            setValue(newValue);
            navigate(validRoutes[newValue].route);
          }}
          sx={{
            backgroundColor: "transparent",
            width: "100%",
            // Garante scroll horizontal se houver muitos itens
            minWidth: validRoutes.length > 4 ? validRoutes.length * 80 : "100%",
            justifyContent: validRoutes.length > 4 ? "flex-start" : "center",
            "& .MuiBottomNavigationAction-root": {
                minWidth: "auto",
                padding: "6px 12px",
                color: "text.secondary",
                "&.Mui-selected": {
                    color: "info.main" // Usa a cor principal do tema
                },
                "& .MuiBottomNavigationAction-label": {
                    fontSize: "0.60rem"
                }
            }
          }}
        >
          {validRoutes.map((route) => (
            <BottomNavigationAction
              key={route.key}
              label={route.name}
              icon={route.icon}
            />
          ))}
        </BottomNavigation>
      </MDBox>
    </Paper>
  );
}

BottomNav.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default BottomNav;
